import '@vebox/etui-system';
import { useContext, Children, createElement } from 'react';
import { _ as _objectWithoutProperties, b as _extends } from '../../_rollupPluginBabelHelpers-3b7bd988.js';
import '@vebox/etui-system-elements';
import AccordionSection from '../../Accordion/AccordionSection.js';
import '../../H5/H5.js';
import '../../Svg-0180d7b5.js';
import '../../Icon/Icon.js';
import '@vebox/etui-icons';
import '../../Icon/icons.js';
import '../../Icon/helper.js';
import '../../Accordion/utils/focus.js';
import 'react-spring/renderprops.cjs';
import '../../Badge/Badge.js';
import '../../ClickOutside/ClickOutside.js';
import '../../Tooltip/Tooltip.js';
import 'lodash.isnil';
import { getTotalNumberOfFilters } from '../utils.js';
import FilterPanelContext from '../FilterPanelContext.js';
import GroupTitle from './GroupTitle.js';

const _excluded = ["children", "name", "infoTooltip", "isSummary", "relatedFields"];
const Group = _ref => {
  let {
      children,
      name,
      infoTooltip,
      isSummary = false,
      relatedFields
    } = _ref,
    rest = _objectWithoutProperties(_ref, _excluded);
  const {
    state
  } = useContext(FilterPanelContext);
  const groupFields = relatedFields !== null && relatedFields !== undefined ? relatedFields : Children.toArray(children).map(child => {
    var _child$props;
    return child === null || child === void 0 ? void 0 : (_child$props = child.props) === null || _child$props === void 0 ? void 0 : _child$props.field;
  }).filter(field => !!field);
  const numberOfFilters = isSummary ? getTotalNumberOfFilters(state.toBeAppliedFilters) : getTotalNumberOfFilters(state.toBeAppliedFilters, groupFields);
  return /*#__PURE__*/createElement(AccordionSection, _extends({
    key: name,
    name: name,
    renderHeader: isOpen => /*#__PURE__*/createElement(GroupTitle, {
      isOpen: isOpen,
      title: name,
      infoTooltip: infoTooltip,
      numberOfAppliedFilters: numberOfFilters
    })
  }, rest), children);
};

export default Group;
